import React, { useState } from "react";
import "./Plan_Purchase_step_form.css";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Nav, Tab } from "react-bootstrap";
import RedRoundBtn from "../../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";
import Gray_btn from "../../../Common_Component/Common_Btn/Gray_btn/Gray_btn";
import Plan_Purchase_step_one from "./Plan_Purchase_step_one/Plan_Purchase_step_one";
import Plan_Purchase_step_two from "./Plan_Purchase_step_two/Plan_Purchase_step_two";
import Plan_Purchase_step_three from "./Plan_Purchase_step_third/Plan_Purchase_step_third";
import Plan_Purchase_step_four from "./Plan_Purchase_step_fourth/Plan_Purchase_step_fourth";
import ProgressBar from "@ramonak/react-progress-bar";
import Contact_Success_Modal from "../../../Common_Component/Common_Modal/Contact_Success_Modal/Contact_Success_Modal";
import { useForm } from "react-hook-form";
import {
  ContactUsForm,
  InsurencePurches,
} from "../../../../utils/apis/form/form";

function Plan_Purchase_step_form({
  activeStepIndex,
  setActiveStepIndex,
  steps,
  data,
  insurance,
}) {
  const [showModal, setShowModal] = useState(false);
  const progress = ((activeStepIndex + 1) / steps.length) * 100;
  const [formdata, setFormdata] = useState(false);
  const handleNext = () => {
    if (activeStepIndex < steps.length - 1) {
      setActiveStepIndex(activeStepIndex + 1);
    }
  };

  const handleBack = () => {
    if (activeStepIndex > 0) {
      setActiveStepIndex(activeStepIndex - 1);
    }
  };
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  console.log(insurance, "insurance insurance insurance");

  const onSubmit = async () => {
    if (
      !data?.id ||
      !insurance?.id ||
      !formdata?.name ||
      !formdata?.email ||
      !formdata?.annual_income ||
      !formdata?.occupation?.value ||
      !formdata?.qualification?.value ||
      !formdata?.pincode ||
      !formdata?.city ||
      !formdata?.nationality_id?.value
    ) {
      alert("Please fill in all required fields.");
      return;
    }
    const formData = new FormData();
    formData.append("loan_form_id", data?.id);
    formData.append("insurance_id", insurance?.id);
    formData.append("name", formdata?.name);
    formData.append("email", formdata?.email);
    formData.append("annual_income", formdata?.annual_income);
    formData.append("occupation", formdata?.occupation.value);
    formData.append("qualification", formdata?.qualification.value);
    formData.append("pincode", formdata?.pincode);
    formData.append("city", formdata?.city);
    formData.append("nationality_id", formdata?.nationality_id?.value);

    const res = await InsurencePurches(formData);
    if (res?.success) {
      setShowModal(true);
    } else {
    }
  };

  const onNextStep = async () => {
    console.log("validated data from current step");
    const isValid = await trigger(); // validates current step
    if (isValid) {
      const formData = getValues();
      setFormdata(formData);
      handleNext();
    }
  };

 
  // const onNextStep = handleSubmit((data) => {
  //   console.log(data, "validated data from current step");
  //   handleNext();
  // });

  const stepComponents = [
    <Plan_Purchase_step_one
      onSubmit={onSubmit}
      setShowModal={setShowModal}
      errors={errors}
      handleSubmit={handleSubmit}
      register={register}
      control={control}
    />,
    <Plan_Purchase_step_two
      onSubmit={onSubmit}
      setShowModal={setShowModal}
      errors={errors}
      handleSubmit={handleSubmit}
      register={register}
      control={control}
    />,
    // <Plan_Purchase_step_three />,
    <Plan_Purchase_step_four
      insurance={insurance}
      data={data}
      val={getValues()}
    />,
  ];

  return (
    <div className="Plan_Purchase_step_form">
      <Tab.Container activeKey={steps[activeStepIndex]}>
        <div className="row">
          {activeStepIndex < steps.length - 1 && (
            <div className="col-md-3">
              <div className="tab_section_holder">
                <Nav variant="pills" className="flex-column">
                  {steps.map((step, index) => (
                    <Nav.Item key={index}>
                      <Nav.Link
                        eventKey={step}
                        onClick={() => setActiveStepIndex(index)}
                      >
                        <div className="tab_text_holder">
                          <div className="text_holder">
                            <p>{step}</p>
                            <h4>{step}</h4>
                          </div>
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              className="caret_icon"
                              icon={faCaretDown}
                            />
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </div>
            </div>
          )}

          <div
            className={
              activeStepIndex === steps.length - 1 ? "col-12" : "col-md-9"
            }
          >
            <div className="step_form_section_holder">
              {activeStepIndex < steps.length - 1 && (
                <div className="main_pregress_holder">
                  <div className="progress_bar_holder">
                    <ProgressBar
                      completed={progress}
                      maxCompleted={100}
                      height="5px"
                      className="progressbar_holder"
                      baseBgColor="#EEF3FF"
                      bgColor="linear-gradient(180deg, #bf2600 0%, #ff714d 6%, #e83b10 14%, #6e1600 100%)"
                      borderRadius="5px"
                      isLabelVisible={false}
                    />
                  </div>
                  <div className="main_step_indicator">
                    <div className="step-indicator">
                      <span>{`${activeStepIndex + 1}/${steps.length}`}</span>
                      <p>Add-on Riders</p>
                    </div>
                  </div>
                </div>
              )}

              {/* <Tab.Content>
                {steps.map((step, index) => (
                  <Tab.Pane eventKey={step} key={step}>
                    <div className="Form_holder">
                      {stepComponents[index]}
                      <div className="btn_holder">
                        {index > 0 && index !== steps.length - 1 && (
                          <Gray_btn btn_name="Back" onClick={handleBack} />
                        )}
                        {index < steps.length - 2 ? (
                          <RedRoundBtn btn_name="Proceed"  onClick={onNextStep} />
                        ) : index === steps.length - 2 ? (
                          <RedRoundBtn btn_name="Review Details" onClick={handleNext} />
                        ) : (
                          <div className="last_step_btn_holder">
                            <div className="btn_holder">
                              <Form>
                                <Form.Check
                                  type="checkbox"
                                  id="custom-switch"
                                  label="I agree to the terms and conditions"
                                />
                              </Form>
                            </div>
                            <div className="btn_holder">
                              <Gray_btn btn_name="Back" onClick={handleBack} />
                              <RedRoundBtn btn_name="Check Out"
                              // type="submit"
                                onClick={() => {
                                  setShowModal(true)
                                }}
                               
                                 />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                ))}
              </Tab.Content> */}

              <Tab.Content>
                <Tab.Pane eventKey={steps[activeStepIndex]}>
                  <div className="Form_holder">
                    {stepComponents[activeStepIndex]}{" "}
                    {/* 👈 Only one step shown */}
                    <div className="btn_holder">
                      {activeStepIndex > 0 && (
                        <Gray_btn btn_name="Back" onClick={handleBack} />
                      )}
                      {activeStepIndex < steps.length - 2 ? (
                        <RedRoundBtn btn_name="Proceed" onClick={onNextStep} />
                      ) : activeStepIndex === steps.length - 2 ? (
                        <RedRoundBtn
                          btn_name="Review Details"
                          onClick={handleNext}
                        />
                      ) : (
                        <div className="last_step_btn_holder">
                          <Form>
                            <Form.Check
                              type="checkbox"
                              id="custom-switch"
                              label="I agree to the terms and conditions"
                            />
                          </Form>
                          <div className="btn_holder">
                            <Gray_btn btn_name="Back" onClick={handleBack} />
                            <RedRoundBtn
                              btn_name="Check Out"
                              onClick={() => onSubmit()}

                              // onClick={() => setShowModal(true)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </div>
      </Tab.Container>

      {showModal && (
        <Contact_Success_Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          title="Plan Purchased Successfully!"
        />
      )}
    </div>
  );
}

export default Plan_Purchase_step_form;
